import { useContext, useEffect, useState, useMemo, useRef, useCallback } from "react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Toast from "../../common/components/ui/toast";
import VehicleSituation from "./VehicleSituation";
import { IIndicators } from "../../types/Indicators.type";
import Loading from "../../common/components/ui/loading/Loading";
import { getAmbassadorByEmail } from "../../common/services/ambassador";
import ModalEditAmbassador from "../../modules/ambassador/modals/EditAmbassador";
import LinkAmbassador from "../../modules/ambassador/modals/LinkAmbassador";
import { AuthContext } from "../../common/components/auth/authContext/AuthContext";
import { useToastContext } from "../../common/components/ui/toast/toast.context";
import { useLocation } from "react-router-dom";

function Home() {
  const location = useLocation();
  const { showToast } = useToastContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const notifySuccess = (text: string) => showToast({ text, type: "success" });

  const { auth, authReady } = useContext(AuthContext);

  const rolesRef = useRef<string[]>([]);
  const rolesLoadedRef = useRef(false);

  if (auth && auth?.user?.roles?.length > 0 && !rolesLoadedRef.current) {
    rolesRef.current = auth.user.roles;
    rolesLoadedRef.current = true;
  }

  const [dataAmbassador, setDataAmbassador] = useState<IIndicators>();
  const [pendingDataAmbassador, setPendingDataAmbassador] = useState(false);
  const [openModalLink, setOpenModalLink] = useState(false);

  const roles = useMemo(() => {
    return rolesLoadedRef.current
      ? rolesRef.current
      : (auth?.user?.roles || []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesLoadedRef.current, rolesRef.current, auth?.user?.roles]);
  const isAmbassador = roles.length === 1 && roles.includes("ambassador");
  const userEmail = auth?.user?.email || "";

  const shouldRender = authReady || rolesLoadedRef.current;

  useEffect(() => {

    const message = location.state?.message;

    if (message) {
      showToast({ text: message, type: "error" });
      window.history.replaceState({}, document.title); //  limpar a mensagem para não repetir se atualizar a página
    }
    
  }, [location.state, showToast]);

  useEffect(() => {
  
    if (!isAmbassador || !userEmail) return;


    const getDataAmbassador = async () => {
      try {
        const result = await getAmbassadorByEmail(userEmail);

        if (result.ok && result.data?.[0]) {
          const data = result.data[0];
          if (data.cpf === "") {
            setPendingDataAmbassador(true);
          }
          setDataAmbassador(data);
        }
      } catch (error) {
        console.error(error);
      } 
    };

    getDataAmbassador();
  }, [isAmbassador, userEmail]);

  const updatedAmbassador = useCallback(() => {
    notifySuccess(`Dados atualizados!`);
    setPendingDataAmbassador(false);
    setOpenModalLink(true);
  }, [notifySuccess]);

  const handleCloseModalLink = useCallback(() => {
    setOpenModalLink(false);
  }, []);

  const dashboardContent = useMemo(() => (
    <Dashboard>
      <VehicleSituation />
    </Dashboard>
  ), []);

  if (!shouldRender) {
    return <Loading />;
  }

  return (
    <ToastProvider>
      <>
        {isAmbassador && dataAmbassador && pendingDataAmbassador && (
          <ModalEditAmbassador
            onClose={updatedAmbassador}
            data={dataAmbassador}
          />
        )}
        <LinkAmbassador
          open={openModalLink}
          onClosed={handleCloseModalLink}
          data={dataAmbassador}
        />
        {/* {isLoading && <Loading />} */}
        {dashboardContent}
        <Toast />
      </>
    </ToastProvider>
  );
}
export default Home;